import React, { useMemo, useEffect, useState } from "react";
import PropTypes from "prop-types";
import * as url from "../../helpers/common_helper";

// import components
import Breadcrumbs from "components/Common/Breadcrumb";
import DataTable from "../../components/Common/LocalizedDataTable";
import { UserApis } from "apis/UserApi"; // ✅ Correct API import
import { useHistory, useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";
import config from "config/config";
import "bootstrap/dist/css/bootstrap.min.css";
import { formatNumber } from "helpers/language_helper";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

function AllUsers(props) {
  const query = useQuery();
  const history = useHistory();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeData, setActiveData] = useState({
    page: 1,
    totalPage: 1,
    search: "",
    limit: config.LIMIT,
  });

  useEffect(() => {
    getUsers(activeData);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getUsers({ ...activeData });
    // eslint-disable-next-line
  }, [query]);

  const columns = [
    {
      name: props.t("Sr.No"),
      selector: (row) => row.sr_no,
      cell: (row) => formatNumber(row.sr_no),
      sortable: false,
    },
    {
      name: props.t("User ID"),
      selector: (row) => row.user_id,
      sortable: true,
    },
    {
      name: props.t("Full Name"),
      selector: (row) => row.full_name,
      sortable: true,
    },
    { name: props.t("Email"), selector: (row) => row.email, sortable: true },
    { name: props.t("Role"), selector: (row) => row.role, sortable: true },
    { name: props.t("Status"), selector: (row) => row.status, sortable: true },
    { name: props.t("Action"), selector: (row) => row.action },
  ];

  const getUsers = (dataParams) => {
    setLoading(true);
    UserApis.getUsers({
      page: dataParams.page,
      limit: dataParams.limit,
      search: dataParams.search,
    })
      .then((res) => {
        const apiData = res?.data?.data || []; // ✅ users are inside data array
        const pagination = res?.data?.pagination || {};

        setActiveData({
          page: dataParams.page,
          totalPage: pagination.total || apiData.length,
          search: dataParams.search,
          limit: dataParams.limit,
        });

        let users = [];
        apiData.forEach((v, i) => {
          users[i] = {
            sr_no: (dataParams.page - 1) * dataParams.limit + (i + 1),
            user_id: v.id,
            full_name: [v.firstname, v.middlename, v.lastname]
              .filter(Boolean)
              .join(" "),
            email: v.email || "-",
            phone: v.phone || "-",
            role: v.role_name || "-",
            status: (
              <span
                style={{
                  fontSize: "13px",
                  fontWeight: "500",
                  color: v.status === 1 ? "#28a745" : "#dc3545",
                }}
              >
                {v.status === 1 ? props.t("Active") : props.t("Inactive")}
              </span>
            ),

            action: (
              <button
                className="btn btn-sm btn-link"
                onClick={() => history.push(`/view-user/${v.id}`)}
              >
                <i className="fas fa-eye" title={props.t("View")} />
              </button>
            ),
          };
        });

        setData(users);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log("❌ Error fetching users:", err);
      });
  };

  const handleChange = (page) => {
    const updatedData = { ...activeData, page };
    setActiveData(updatedData);
    getUsers(updatedData);
  };

  const handleRowChange = (limit) => {
    const updatedData = { ...activeData, limit, page: 1 }; // reset page when limit changes
    setActiveData(updatedData);
    getUsers(updatedData);
  }; 

  // meta title
  document.title = props.t("All Users") + " | " + props.t("Salon");

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs
          title={props.t("Users")}
          breadcrumbItem={props.t("All Users")}
        />
      </div>
      <div className="container-fluid">
        <DataTable
          className="table-bordered"
          progressPending={loading}
          columns={columns}
          data={data}
          pagination
          paginationServer
          paginationTotalRows={activeData.totalPage}
          paginationPerPage={activeData.limit}
          onChangeRowsPerPage={handleRowChange}
          onChangePage={handleChange}
          noHeader
          highlightOnHover
        />
      </div>
    </div>
  );
}

AllUsers.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(AllUsers);
